module.exports = __webpack_public_path__ + "static/media/end_of_lesson.fe062edc.svg";